import React from 'react';

export const Placeholder2 = () => (
  <div id="placeholder-2">Hello from Placeholder2</div>
);
